export default "__VITE_ASSET__23568688__"